export default __webpack_public_path__ + "static/media/icon-study.1f0a65e4.svg";